import Category from '../category';

/**
 * Create the action
 */

const { thunk, request, success, error } = Category.index((fetch) =>
  fetch.get('/post-categories')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
